export const alignments: { [key: string]: string } = {
  L: 'flex-start',
  C: 'center',
  R: 'flex-end',
};

export const sizes: { [key: string]: number } = {
  S: 48,
  M: 64,
  L: 96,
};

export const dimensions: { [key: string]: { w: number; h: number } } = {
  S: { w: 5, h: 7.5 },
  M: { w: 7.5, h: 11.25 },
  L: { w: 10, h: 15 },
};

export const lineheights: { [key: string]: number } = {
  S: 0.75,
  M: 1,
  L: 1.5,
};

export const PIXEL_RATIO = sizes.M / dimensions.M.h;

export const CAPITAL_WIDTH_MODIFIER = 1.2;

type eSupport = 'HOLLOW' | 'SHAPE' | 'FULL' | 'STAND';
export const support: eSupport = 'FULL';

export const weights: { [key: string]: string } = { MEDIUM: 'initial', BOLD: 'bold', THIN: 'lighter' };

export const fontFamilyModifiers: { [key: string]: number } = {
  'MoonTime.ttf': 1.8,
  'Plaything.ttf': 1,
  'Bestie.ttf': 1.2,
  'BFF.ttf': 1.25,
  'Clickbait.ttf': 0.75,
  'Clout.ttf': 0.9,
  'Comment.ttf': 1,
  'Gamble.ttf': 1.8,
  'Glow.ttf': 0.95,
  'Instaneon.ttf': 1.6,
  'Like.ttf': 1.1,
  'Love Island.ttf': 1.1,
  'Love.ttf': 1.2,
  'Midnight Champion.ttf': 1.25,
  'Notification.ttf': 1,
  'Pan Am.ttf': 1.6,
  'Rather.ttf': 1.15,
  'Selfie.ttf': 2.1,
  'Share.ttf': 1.2,
  'Sub.ttf': 1.2,
  'Tag.ttf': 1,
  'Tweet.ttf': 1.5,
  'Viral.ttf': 0.75,
};

export const fontSizes: {
  [key: string]: { UPPER_ABOVE: number; UPPER_BELOW: number; LOWER_ABOVE: number; LOWER_BELOW: number };
} = {
  Huns: {
    UPPER_ABOVE: 18,
    UPPER_BELOW: 0,
    LOWER_ABOVE: 16,
    LOWER_BELOW: 4,
  },
  BFF: {
    UPPER_ABOVE: 6,
    UPPER_BELOW: 0,
    LOWER_ABOVE: 6,
    LOWER_BELOW: 0,
  },
  Instaneon: {
    UPPER_ABOVE: 12,
    UPPER_BELOW: 3,
    LOWER_ABOVE: 10,
    LOWER_BELOW: 5,
  },
  Bestie: {
    UPPER_ABOVE: 12,
    UPPER_BELOW: 0,
    LOWER_ABOVE: 11,
    LOWER_BELOW: 7,
  },
  'Love island': {
    UPPER_ABOVE: 7,
    UPPER_BELOW: 0,
    LOWER_ABOVE: 9,
    LOWER_BELOW: 5,
  },
  Clout: {
    UPPER_ABOVE: 8,
    UPPER_BELOW: 0,
    LOWER_ABOVE: 8,
    LOWER_BELOW: 2,
  },
  Clickbait: {
    UPPER_ABOVE: 8,
    UPPER_BELOW: 4,
    LOWER_ABOVE: 7,
    LOWER_BELOW: 4,
  },
  Selfie: {
    UPPER_ABOVE: 12,
    UPPER_BELOW: 0,
    LOWER_ABOVE: 12,
    LOWER_BELOW: 0,
  },
  Repost: {
    UPPER_ABOVE: 5,
    UPPER_BELOW: 0,
    LOWER_ABOVE: 5,
    LOWER_BELOW: 0,
  },
  Share: {
    UPPER_ABOVE: 10,
    UPPER_BELOW: 3,
    LOWER_ABOVE: 11,
    LOWER_BELOW: 4,
  },
  Tag: {
    UPPER_ABOVE: 12,
    UPPER_BELOW: 1,
    LOWER_ABOVE: 11,
    LOWER_BELOW: 8,
  },
  Like: {
    UPPER_ABOVE: 10,
    UPPER_BELOW: 5,
    LOWER_ABOVE: 6,
    LOWER_BELOW: 6,
  },
  Sub: {
    UPPER_ABOVE: 11,
    UPPER_BELOW: 5,
    LOWER_ABOVE: 12,
    LOWER_BELOW: 7,
  },
  Tweet: {
    UPPER_ABOVE: 11,
    UPPER_BELOW: 6,
    LOWER_ABOVE: 9,
    LOWER_BELOW: 7,
  },
  Glow: {
    UPPER_ABOVE: 5,
    UPPER_BELOW: 0,
    LOWER_ABOVE: 5,
    LOWER_BELOW: 0,
  },
  Midnight: {
    UPPER_ABOVE: 12,
    UPPER_BELOW: 0,
    LOWER_ABOVE: 12,
    LOWER_BELOW: 4,
  },
  Notification: {
    UPPER_ABOVE: 10,
    UPPER_BELOW: 4,
    LOWER_ABOVE: 14,
    LOWER_BELOW: 10,
  },
  DM: {
    UPPER_ABOVE: 14,
    UPPER_BELOW: 4,
    LOWER_ABOVE: 11,
    LOWER_BELOW: 6,
  },
  Love: {
    UPPER_ABOVE: 7,
    UPPER_BELOW: 0,
    LOWER_ABOVE: 7,
    LOWER_BELOW: 2,
  },
  Gamble: {
    UPPER_ABOVE: 9,
    UPPER_BELOW: 1,
    LOWER_ABOVE: 9,
    LOWER_BELOW: 2,
  },
  Viral: {
    UPPER_ABOVE: 3,
    UPPER_BELOW: 0,
    LOWER_ABOVE: 3,
    LOWER_BELOW: 0,
  },
  Plaything: {
    UPPER_ABOVE: 6,
    UPPER_BELOW: 0,
    LOWER_ABOVE: 6,
    LOWER_BELOW: 0,
  },
  Rather: {
    UPPER_ABOVE: 11,
    UPPER_BELOW: 4,
    LOWER_ABOVE: 9,
    LOWER_BELOW: 8,
  },
  'Pan Am': {
    UPPER_ABOVE: 12,
    UPPER_BELOW: 0,
    LOWER_ABOVE: 12,
    LOWER_BELOW: 0,
  },
  Comment: {
    UPPER_ABOVE: 10,
    UPPER_BELOW: 2,
    LOWER_ABOVE: 10,
    LOWER_BELOW: 3,
  },
};

export const tailedLetters = 'gjpqy';
